import type { CurrencyId } from "@rarible/types"

export type { CurrencyId }

export function toCurrencyId(value: string): CurrencyId {
  return value as CurrencyId
}

export interface Currency {
  id: CurrencyId
  abbreviation: string
  usdExchangeRate?: string
  icon?: string
}

export interface PriceValue {
  amount: string
  currency: Currency
}

const UNKNOWN_CURRENCY_ID = "UNKNOWN" as CurrencyId

export const UNKNOWN_CURRENCY: Currency = {
  id: UNKNOWN_CURRENCY_ID,
  abbreviation: "UNKNOWN",
}
